export enum Vertical {
  ARTIST = 'artist',
  CONSUMER = 'consumer',
}

export const isVertical = (value: unknown): value is Vertical =>
  typeof value === 'string' && Object.values(Vertical).includes(value as Vertical);
